export default {
  ERRORS: {
    EMAIL_SIGN_IN_ERROR: "EMAIL_SIGN_IN_ERROR",
    MISSING_EMAIL: "MISSING_EMAIL",
  },
  USER_EMAIL_LOCALSTORAGE_KEY: "p0_user_email",
  OIDC_ORG_SLUG_KEY: "p0-oidc-orgslug",
  PERSIST_AUTH_KEY: "p0-persist-auth",
};
